import { prop, isNil, not, compose, path } from 'ramda';
import { safe, chainSafe, mapM } from '../Utils/MaybeUtils';
import { Maybe } from 'true-myth';
import { maybeToResult } from '../Utils/Result';
import { IClientBusinessModel } from '../Types/ClientModelTypes';
import {
  collectionTypeNameToFieldName,
  getAttributeInfo,
} from './avenyModelUtils';
import { findCollectionStatic } from './avenyStaticModelUtils';
import { IColumnDef } from '../Types/ColumnDefType';
import { INodeData } from '../Components/QueryComponents/NodeQuery/NodeQuery';
import { IFormData } from '../Features/Delsystem/_Common/Components/BusinessCollectionComponents/BusinessDataForm/Utils/BusinessDataFormUtils';
import { IIntegratedContentName } from '../Features/Delsystem/_Common/Components/BusinessCollectionComponents/IntegratedAssociationList/IntegratedAssociationList';
import { businessDataFormValuesEqual } from '../Features/Delsystem/_Common/Components/BusinessCollectionComponents/BusinessDataForm/BusinessDataFormHasChanged/businessDataFormHasChanged';

export const validCollectionFieldName: any = compose(
  not,
  isNil,
  findCollectionStatic
);

export const validCollectionTypeName: any = compose(
  Maybe.unwrapOr(false),
  mapM(not),
  mapM(isNil),
  mapM(findCollectionStatic as any),
  collectionTypeNameToFieldName
);

export const associationMaybe = (associationName: string) =>
  compose(
    (chainSafe as any)(prop(associationName)),
    safe((bm: IClientBusinessModel) => bm.Associations)
  );

export const getAssociationResult = (associationName: string) =>
  compose(
    maybeToResult(`${associationName} saknas`),
    associationMaybe(associationName) as any
  );

export const getCaption = (
  column: IColumnDef,
  collection: IClientBusinessModel,
  avenyCollectionMap: Map<string, IClientBusinessModel>
): string => {
  return column.caption != null
    ? column.caption
    : column.association
    ? column.association
    : getAttributeInfo(collection, column.attributeDef, avenyCollectionMap)
        .attribute.DisplayLabel;
};

export const getAssociationLabel = (
  label: IIntegratedContentName,
  collection: IClientBusinessModel
): string => {
  const model = label.association
    ? collection.Associations[label.name]
    : collection.Attributes[label.name];
  return label.label ?? model?.DisplayLabel ?? label.name;
};

export const getAssociationValue = (
  associationName: string,
  editedValues: INodeData | IFormData,
  attribute: string,
  data?: INodeData,
  association?: boolean
): string | undefined => {
  const dataPath = association
    ? ['_Associations', associationName as string, attribute]
    : [attribute];
  const dataValue = data && (path(dataPath, data) as string);
  const editedPath = association
    ? ['_Associations', `${associationName}_Ref`]
    : [`${associationName}_Ref`];
  const editedValue: any = path(editedPath, editedValues);
  return editedValue !== undefined
    ? typeof editedValue === 'string'
      ? editedValue
      : editedValue?.id
    : dataValue ?? '';
};

export const getEditedAssociation = (
  associationName: string,
  editedValues: INodeData | IFormData,
  attribute: string,
  data?: INodeData,
  association?: boolean
) => {
  const dataPath = association
    ? ['_Associations', associationName as string, attribute]
    : [attribute];
  const dataValue = data && (path(dataPath, data) as string);
  const editedPath = association
    ? ['_Associations', `${associationName}_Ref`]
    : [`${associationName}_Ref`];
  const editedValue = path(editedPath, editedValues) as string;
  return (
    editedValue !== undefined &&
    !businessDataFormValuesEqual(dataValue, editedValue)
  );
};
